import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';

import { RouterModule } from '@angular/router';

import { HomeRoutingModule } from './home-routing.module';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';


import { HomeComponent } from './home.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';



import { MatButtonModule } from '@angular/material/button';
import { UsersModule } from './users/users.module';
import { BillingModule } from './billing/billing.module';
import { ProvidersModule } from './providers/providers.module';
import { CrmModule } from './crm/crm.module';


import { SharedModule } from 'src/shared/shared.module';

@NgModule({
  declarations: [
    HomeComponent,
    DashboardComponent,

  ],
  imports: [
    UsersModule,
    ProvidersModule,
    CrmModule,
    CommonModule,
    HomeRoutingModule,
    HttpClientModule,
    RouterModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    FormsModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatSelectModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatIconModule,
    MatFormFieldModule,
    MatListModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatCardModule,
    MatButtonModule,
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    BillingModule,
    SharedModule,
  ],
  exports: [
    HomeComponent
  ],
  providers: [DatePipe],
})
export class HomeModule { }
